import {request} from "../request/request";

const city = {
  findAll: (params) => request.read('/city', params, true),
  findOne: (params) => request.read('/city/find', params, true),
  getOne: (cityId) => request.read(`/city/${cityId}`, null, true),
};

export {city};